<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Mobile payment'"
    />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <Input
        :leftIcon="PhoneSvg"
        :placeholder="'Phone number'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="DollarSvg"
        :placeholder="'Amount'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <div :class="'row-center-space-between'">
        <span :class="'t14'">Your balance: 4 863.27 USD</span>
        <span :class="'t14'">No fees</span>
      </div>
      <Button
        :title="'Confirm'"
        :style="{marginTop: '30px'}"
        @click="$router.push(routes.PAYMENT_SUCCESS)"
      />
    </main>
  </div>
</template>

<script setup>
// others
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

// components
import {Input} from '@/components';
import {Header} from '@/components';
import {Button} from '@/components';

// svg
import {PhoneSvg} from '@/assets/svg';
import {DollarSvg} from '@/assets/svg';
import {Background} from '@/components';

const opacity = useOpacity();
</script>
